import './button.css';
import { useRef } from 'react';

export default function UploadOTUFile({ children, onFileChange, disabled }) {
    const fileInputRef = useRef(null);

    const handleClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <>
            <button
                type="button"
                className="mybutton"
                onClick={handleClick}
                disabled={disabled}
            >
                {children}
            </button>
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={onFileChange}
                accept=".csv,.tsv"
                multiple
                disabled={disabled}
            />
        </>
    );
}